import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap'
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';




class ContractDetailsCard extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            user: props.user,
            loadingData: false,
            data: props.data
        };

        this.showButtons = this.showButtons.bind(this);
    }

    showButtons() {
        if (moment().add(90, 'days').isAfter(moment(this.state.data.EndDate))) {
            return  <Col md={4} style={{ marginTop: 3, marginBottom: 3, display: 'flex', flexDirection: 'column' }}>
                        <Button as={Link} to={{
                            pathname: "/site_visits",
                            state: {
                                user: this.state.user,
                                data: this.state.data
                            }
                        }} size="sm" style={{ width: '100%', height: '100%', marginBottom: '3px', }} variant="secondary">View Contract Service Notes</Button>
                        <Button as={Link} to={{
                            pathname: "/contract_renewal_request",
                            state: {
                                user: this.state.user,
                                data: this.state.data
                            }
                        }}  size="sm" style={{ width: '100%', height: '100%', marginTop: '3px', backgroundColor: '#ED7D31' }} variant="secondary">Request renewal</Button>
                    </Col>;

        }
        else {
            return <Col md={4} style={{ marginTop: 3, marginBottom: 3 }}>
                <Button as={Link} to={{
                    pathname: "/site_visits",
                    state: {
                        user: this.state.user,
                        data: this.state.data
                    }
                }} size="sm" style={{ width: '100%', align: 'vertical', display: 'inline-block' }} variant="secondary">View Contract Service Notes</Button>
            </Col>;
        }
    }

    handleContractEndDate() {
        let color = (moment().add(90, 'days').isAfter(moment(this.state.data.EndDate))) ? '#ED7D31' : '#00973A';
        return < Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', color: color, fontWeight:'450' }}> Active Until {moment(this.state.data.EndDate).format('MM/DD/YYYY')}</Form.Label >
    }

    render() {
        return (
            <div class={this.props.class}>
                <Row style={{paddingLeft:5}}>
                    <Col md={2} >
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{moment(this.state.data.CreatedDate).format('MM/DD/YYYY')}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.OrderNumber}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.ContractNumber}</Form.Label>
                        <br/>
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.PurchaseOrder}</Form.Label>
                    </Col>
                    <Col md={3} >
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold' }}>{this.state.data.BuildingName}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.OrderDescription}</Form.Label>
                        <br />
                        {this.handleContractEndDate()}
                    </Col>
                    {this.showButtons()}
                    <Col md={3} style={{ marginTop: 3, marginBottom: 3, display: 'flex', flexDirection: 'column' }}>
                        <Button as={Link} to={{
                            pathname: "/scheduling_request",
                            state: {
                                user: this.state.user,
                                data: this.state.data
                            }
                        }} size="sm" className="stacked-button-top" variant="primary">Scheduling Request</Button>
                        <Button as={Link} to={{
                            pathname: "/order_inquiry",
                            state: {
                                user: this.state.user,
                                data: this.state.data
                            }
                        }} size="sm" className="stacked-button-bottom" variant="primary">Contract Inquiry</Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ContractDetailsCard;